import React from 'react'
import Header from '../Header/Header'
import DayBasedOrderData from '../../Components/Admin/DayBasedOrderData/DayBasedOrderData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function DayBasedOrders() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <DayBasedOrderData />
                </div>
            </section>
        </div>
    )
}
